import { render, staticRenderFns } from "./TopLocationBackgroundShape2.vue?vue&type=template&id=5cd6c2a6&scoped=true&"
import script from "./TopLocationBackgroundShape2.vue?vue&type=script&lang=js&"
export * from "./TopLocationBackgroundShape2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6c2a6",
  null
  
)

export default component.exports